import TouchModule from '../../features/touch';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __depends__: [
    TouchModule
  ]
};